// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const SpecificationsHeading = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.specificationsHeading"
        description="Specifications heading."
        defaultMessage="Basic Specifications"
    />
);
SpecificationsHeading.displayName = "SpecificationsHeading";

export const AspectRatio = (props: { aspectRatio: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.aspectRatio"
        description="Aspect ratio."
        defaultMessage="Aspect ratio: {aspectRatio}"
        values={props}
    />
);
AspectRatio.displayName = "AspectRatio";

export const Resolution = (props: { resolution: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.resolution"
        description="Resolution."
        defaultMessage="Minimum Resolution: {resolution}"
        values={props}
    />
);
Resolution.displayName = "Resolution";

export const VideoSize = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.videoSize"
        description="Video size."
        defaultMessage="Video: 32MB Max"
    />
);
VideoSize.displayName = "VideoSize";

export const VideoMinLength = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.videoMinLength"
        description="Video min length."
        defaultMessage="Minimum Video Length: 1 sec"
    />
);
VideoMinLength.displayName = "VideoMinLength";

export const ImageSize = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.imageSize"
        description="Image size."
        defaultMessage="Image: 10MB Max"
    />
);
ImageSize.displayName = "ImageSize";

export const TipsHeading = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.tipsHeading"
        description="Tips heading."
        defaultMessage="Creating a Great Preview"
    />
);
TipsHeading.displayName = "TipsHeading";

export const TipsTextLineOne = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.tipsTextLineOne"
        description="Tips text line one."
        defaultMessage="Keep the preview short and to the point."
    />
);
TipsTextLineOne.displayName = "TipsTextLineOne";

export const TipsTextLineTwo = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.tipsTextLineTwo"
        description="Tips text line two."
        defaultMessage="Make sure the scene is nicely lit and avoid busy backgrounds."
    />
);
TipsTextLineTwo.displayName = "TipsTextLineTwo";

export const BestPractices = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.bestPractices"
        description="Best practices."
        defaultMessage="For more best practices, check out"
    />
);
BestPractices.displayName = "BestPractices";

export const LinkText = (): ReactElement => (
    <FormattedMessage id="apps.lensPreview.components.linkText" description="Link text." defaultMessage="the guide" />
);
LinkText.displayName = "LinkText";

export const LensPreviewToBeReviewed = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.lensPreviewToBeReviewed"
        description="Lens preview to be reviewed."
        defaultMessage="To Be Reviewed"
    />
);
LensPreviewToBeReviewed.displayName = "LensPreviewToBeReviewed";

export const LensPreviewInvalidLensPreview = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.lensPreviewInvalidLensPreview"
        description="Lens preview invalid lens preview."
        defaultMessage="Invalid Lens Preview"
    />
);
LensPreviewInvalidLensPreview.displayName = "LensPreviewInvalidLensPreview";

export const LensPreviewUpdatedInLensStudio = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.lensPreviewUpdatedInLensStudio"
        description="Lens preview updated in lens studio."
        defaultMessage="Updated"
    />
);
LensPreviewUpdatedInLensStudio.displayName = "LensPreviewUpdatedInLensStudio";

export const LensPreviewChangeCta = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.lensPreviewChangeCta"
        description="Lens preview change cta."
        defaultMessage="Change Lens Preview"
    />
);
LensPreviewChangeCta.displayName = "LensPreviewChangeCta";

export const LensPreviewRemoveCta = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.lensPreviewRemoveCta"
        description="Lens preview remove cta."
        defaultMessage="Remove"
    />
);
LensPreviewRemoveCta.displayName = "LensPreviewRemoveCta";

export const LensPreviewUploadCta = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.lensPreviewUploadCta"
        description="Lens preview upload cta."
        defaultMessage="Upload Video or Image"
    />
);
LensPreviewUploadCta.displayName = "LensPreviewUploadCta";

export const LensPreviewUploadVideoCta = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.lensPreviewUploadVideoCta"
        description="Lens preview upload video cta."
        defaultMessage="Upload Video"
    />
);
LensPreviewUploadVideoCta.displayName = "LensPreviewUploadVideoCta";

export const LensPreviewUploadCtaSpectacles = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.lensPreviewUploadCtaSpectacles"
        description="Lens preview upload cta spectacles."
        defaultMessage="Upload Image"
    />
);
LensPreviewUploadCtaSpectacles.displayName = "LensPreviewUploadCtaSpectacles";

export const LensPreviewAddCta = (props: { actionType: ReactNode; surface: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.lensPreviewAddCta"
        description="Lens preview add cta."
        defaultMessage="{actionType} {surface} Lens Preview"
        values={props}
    />
);
LensPreviewAddCta.displayName = "LensPreviewAddCta";

export const PreviewInReviewTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.previewInReviewTitle"
        description="Preview in review title."
        defaultMessage="Your Lens is in review"
    />
);
PreviewInReviewTitle.displayName = "PreviewInReviewTitle";

export const PreviewInReviewApprovalText = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.previewInReviewApprovalText"
        description="Preview in review approval text."
        defaultMessage="Once approved, you will be able to see your media"
    />
);
PreviewInReviewApprovalText.displayName = "PreviewInReviewApprovalText";

export const PreviewView = (): ReactElement => (
    <FormattedMessage id="apps.lensPreview.components.previewView" description="Preview view." defaultMessage="View" />
);
PreviewView.displayName = "PreviewView";

export const PreviewAdd = (): ReactElement => (
    <FormattedMessage id="apps.lensPreview.components.previewAdd" description="Preview add." defaultMessage="Add" />
);
PreviewAdd.displayName = "PreviewAdd";

export const PreviewSnapchat = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.previewSnapchat"
        description="Preview snapchat."
        defaultMessage="Snapchat"
    />
);
PreviewSnapchat.displayName = "PreviewSnapchat";

export const PreviewSpectacles = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.previewSpectacles"
        description="Preview spectacles."
        defaultMessage="Spectacles"
    />
);
PreviewSpectacles.displayName = "PreviewSpectacles";

export const EditMediaScrubForward = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.editMediaScrubForward"
        description="Edit media scrub forward."
        defaultMessage="Scrub Forward"
    />
);
EditMediaScrubForward.displayName = "EditMediaScrubForward";

export const EditMediaScrubBackward = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.editMediaScrubBackward"
        description="Edit media scrub backward."
        defaultMessage="Scrub Backward"
    />
);
EditMediaScrubBackward.displayName = "EditMediaScrubBackward";

export const EditMediaUseKeyframe = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.editMediaUseKeyframe"
        description="Edit media use keyframe."
        defaultMessage="Use Keyframe"
    />
);
EditMediaUseKeyframe.displayName = "EditMediaUseKeyframe";

export const EditMediaCrop = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.editMediaCrop"
        description="Edit media crop."
        defaultMessage="Crop"
    />
);
EditMediaCrop.displayName = "EditMediaCrop";

export const EditMediaReset = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.editMediaReset"
        description="Edit media reset."
        defaultMessage="Reset"
    />
);
EditMediaReset.displayName = "EditMediaReset";

export const EditMediaSave = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.editMediaSave"
        description="Edit media save."
        defaultMessage="Save"
    />
);
EditMediaSave.displayName = "EditMediaSave";

export const EditMediaExit = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.editMediaExit"
        description="Edit media exit."
        defaultMessage="Exit Edit"
    />
);
EditMediaExit.displayName = "EditMediaExit";

export const EditMediaEdit = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.editMediaEdit"
        description="Edit media edit."
        defaultMessage="Edit"
    />
);
EditMediaEdit.displayName = "EditMediaEdit";

export const LabelSpectaclesPreview = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.labelSpectaclesPreview"
        description="Label spectacles preview."
        defaultMessage="Spectacles Preview"
    />
);
LabelSpectaclesPreview.displayName = "LabelSpectaclesPreview";

export const SpectaclesVideoPreviewError = (): ReactElement => (
    <FormattedMessage
        id="apps.lensPreview.components.spectaclesVideoPreviewError"
        description="Spectacles video preview error."
        defaultMessage="Spectacles Lenses do not support video previews. Please select a keyframe to use as an image."
    />
);
SpectaclesVideoPreviewError.displayName = "SpectaclesVideoPreviewError";

export const messages = defineMessages({
    spectaclesVideoPreviewErrorTitle: {
        id: "apps.lensPreview.components.spectaclesVideoPreviewErrorTitle",
        description: "Spectacles video preview error title.",
        defaultMessage: "Spectacles does not support Video Previews",
    },
    spectaclesVideoPreviewErrorBody: {
        id: "apps.lensPreview.components.spectaclesVideoPreviewErrorBody",
        description: "Spectacles video preview error body.",
        defaultMessage: "Change Lens Preview and upload an image instead.",
    },
    spectaclesModalVideoError: {
        id: "apps.lensPreview.components.spectaclesModalVideoError",
        description: "Spectacles modal video error.",
        defaultMessage: "Spectacles does not support videos. Edit and select a keyframe or upload an image.",
    },
});
